import { useContext } from 'react';
import { FavoriteToggleContext, FavoriteToggleContextType } from '#baseMenu/components/controls/favorite-toggle';

const useFavoriteToggleContext = () => useContext<FavoriteToggleContextType>(FavoriteToggleContext);

export { useFavoriteToggleContext };
